import React from 'react'
import { Grid, GridItem } from '@deal/components'
import classnames from 'classnames'
import styles from './styles.css'

const Heading: React.SFC<React.HTMLAttributes<HTMLHeadingElement>> = ({ className, children }) => {
  return (
    <Grid>
      <GridItem col={2}>
        <h2 className={classnames(className, styles.heading)}>{children}</h2>
      </GridItem>
    </Grid>
  )
}

export default Heading
